import script from "./VaporFileField.vue?vue&type=script&lang=js"
export * from "./VaporFileField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/taylor/Documents/Code/laravel-nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"VaporFileField.vue"]])

export default __exports__